import React from "react";
import { Container } from "@material-ui/core";
import SubmitAPICredentialsForm from "./SubmitAPICredentialsForm";
import ImgHeader from "../ImgHeader";
import BlockQuote from "../BlockQuote";
import { H1, H2 } from "../Headers";
import styled from "styled-components";

const Wrapper = styled(Container)`
  padding: 2em;
  margin: 0;
  max-width: 100%;
`;

export default function SubmitAPICredentials() {
  return (
    <>
      <ImgHeader url="/static/img/Card-SubmitATicket.png" shadowOpacity={0.3}>
        <H1>Test your credentials</H1>
      </ImgHeader>
      <Wrapper>
        <Container>
          <H2>Enter your information to do a quick test</H2>
          <BlockQuote>Do you need to quickly test that your credentials are working? Enter the relevant information below.</BlockQuote>
          <SubmitAPICredentialsForm />
        </Container>
      </Wrapper>
    </>
  );
}
